
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Seo } from '@components/common/Seo';
import { PrContent } from '@components/keyPages/PrContent/PrContent';
import { fetchPr, usePr } from '@queries/usePr';
import { buildPrPageLink } from '@utils/link';
import { withGlobalSettings } from '@utils/pageFetchEnhancer';
import { buildOpenGraph, buildResourceSeoSettings } from '@utils/seo';
import { GetStaticProps } from 'next';
import { ReactElement, useMemo } from 'react';
import { dehydrate } from 'react-query';
import { PageProps } from '../types/page';

export default function PRPage({ seo }): ReactElement {
  const { data } = usePr();
  const url = buildPrPageLink();
  const content = useMemo(() => JSON.parse(data.content), [data.content]);

  return (
    <>
      <Seo
        canonical={url}
        siteName={seo.siteName}
        metaTitle={seo.metaTitle}
        metaDescription={seo.metaDescription}
        openGraph={buildOpenGraph({
          title: seo.shareTitle,
          description: seo.shareDescription,
          type: 'website',
          sitename: seo.siteName,
          url,
          image: {
            url: seo.shareImage?.url,
            width: seo.shareImage?.width,
            height: seo.shareImage?.height,
            alt: seo.shareImage?.alternativeText,
          },
        })}
      />
      <PrContent content={content} />
    </>
  );
}

 const _getStaticProps: GetStaticProps = withGlobalSettings<PageProps>(
  async (nextContext, { queryClient, globalSettingsPromise, adScriptsPromise }) => {
    const [prData, globalSettings, adScripts] = await Promise.all([
      queryClient.fetchQuery('pr', () => fetchPr()),
      globalSettingsPromise,
      adScriptsPromise,
    ]);

    return {
      props: {
        dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
        seo: JSON.parse(
          JSON.stringify(
            buildResourceSeoSettings(
              {
                ...globalSettings.global.seo,
                siteName: globalSettings.global.siteName,
              },
              prData.seo,
            ),
          ),
        ),
        adScripts,
        globalSettings,
      },
      revalidate: 60 * 60 * 24,
    };
  },
);


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/pr',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  